import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ManageUser.css";
import { useNavigate } from "react-router-dom";

const ManageUser = () => {
  const [users, setUsers] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null); // Keep track of which user's dropdown is open
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/user`)
      .then((res) => {
        console.log("res", res);
        setUsers(res.data);
      })
      .catch((err) => console.error("Failed to load users", err));
  }, []);
  

  const handleView = (userId) => {
    navigate(`/admin/users/${userId}`);
    setOpenDropdown(null);
  };

  const handleDelete = async (userId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_SERVER}/api/user/${userId}`);
      setUsers(users.filter((user) => user._id !== userId));
    } catch (err) {
      console.error("Failed to delete user", err);
    }
    setOpenDropdown(null);
  };

  return (
    <div className="user-list-container">
      <h2>User List</h2>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Role</th>
            <th>Joined</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {users
            .filter((user) => user.role !== 1) // 👈 Filter out role 1 users
            .map((user, index) => (
              <tr key={index}>
                <td>{user.username}</td>
                <td>{user.email}</td>
                <td>{user.role}</td>
                <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                <td>
                  <div className="dropdownWrapper">
                    <p
                      className="actionBtn"
                      onClick={() =>
                        setOpenDropdown(openDropdown === index ? null : index)
                      }
                    >
                      ...
                    </p>

                    {openDropdown === index && (
                      <div className="dropdownMenu">
                        <div onClick={() => handleView(user._id)}>View</div>
                        <div onClick={() => handleDelete(user._id)}>Delete</div>
                      </div>
                    )}
                  </div>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default ManageUser;
